import type {
  PesquisaAlmox,
  PesquisaEmpresa,
  PesquisaGrupo,
  PesquisaMarca
} from './pesquisas';

export interface FiltrosCatalogo {
  marcasSelecionadas: PesquisaMarca[];
  almoxarifadosSelecionados: PesquisaAlmox[];
  empresasSelecionadas: PesquisaEmpresa[];
  grupoSelecionados: PesquisaGrupo[];
  
  agruparPor: string;
  ordemSelecionada: string;
  
  dataUltEntInicial?: Date;
  dataUltEntFinal?: Date;
  
  dataCadInicial?: Date;
  dataCadFinal?: Date;
  
  apenasEnviaMobile: boolean;
  apenasComEstoque: boolean;
  apenasAtivo: boolean;
  apenasDisponivel: boolean;
}

export interface GerarCatalogoResponse {
  nomeArquivo: string;
}

export const OPCOES_AGRUPAMENTO = [
  'NAO AGRUPAR',
  'DESCRICAO MARCA',
  'NOME GRUPO', 
  'NOME SUBGRUPO'
] as const;

export const OPCOES_ORDENACAO = {
  'NOME_PRODUTO': 'Por Nome do Produto (A-Z)',
  'CODIGO': 'Por Código do Produto (Menor para Maior)',
  'GRUPO_NOME': 'Por Grupo, depois por Nome',
  'SUBGRUPO_NOME': 'Por Subgrupo, depois por Nome',
  'MARCA_NOME': 'Por Marca, depois por Nome',
  'SUBGRUPO_MARCA_NOME': 'Por Subgrupo, Marca e Nome',
  'GRUPO_MARCA_NOME': 'Por Grupo, Marca e Nome'
} as const;